import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    background: theme.palette.grey[100],
    borderRadius: 8
  },
  imageContainer: {
    width: '240px',
    height: '200px',
    [theme.breakpoints.down('sm')]: {
      width: 100,
      height: 100
    },
    position: 'relative'
  },
  detailsContainer: {
    padding: '16px',
    width: 'calc(100% - 240px)',
    height: 200,
    gridTemplateRows: '1fr 1fr',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      padding: '8px',
      width: 'calc(100% - 100px)',
      height: 100
    }
  },
  nameAndAddressContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  hotelName: { marginBottom: 10 },
  hotelLocation: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginBottom: 6
  },
  iconContainer: {
    marginRight: '2.5px',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex'
  },
  icon: {
    fontSize: 18,
    color: theme.palette.grey[700],
    marginRight: 4
  },
  cityNameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  hotelFacilities: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  priceDetailsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between'
  },
  leftSideContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  bottonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  image: {
    objectFit: 'cover',
    width: '100%',
    height: '100%',
    borderRadius: '8px 0 0 8px'
  },
  textColor: {
    color: theme.palette.grey[600],
    fontWeight: 500,
    margin: '3px 0px'
  },
  title: {
    fontWeight: 600,
    fontSize: 20,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16
    }
  },
  price: {
    fontWeight: 600,
    fontSize: 20,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16
    }
  },
  btnText: { fontWeight: 600, color: theme.palette.grey[700] },
  btn: { padding: '8px 12px', borderRadius: 8, minWidth: 120 },
  ratingConainer: {
    display: 'flex',
    width: 'fit-content',
    background: theme.palette.grey[900],
    opacity: 0.6,
    position: 'absolute',
    top: 10,
    left: 10,
    [theme.breakpoints.down('sm')]: {
      top: 6,
      left: 6
    },
    alignItems: 'flex-end',
    padding: '4px 8px',
    borderRadius: 6
  },
  ratingIcon: {
    color: '#ffb400',
    fontSize: 18,
    marginRight: 4,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      marginRight: 2
    }
  },
  iconText: {
    lineHeight: 1,
    fontWeight: 600,
    marginBottom: 1,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0
    },
    color: theme.palette.primary.contrastText
  },
  facility: {
    marginLeft: 4,
    color: theme.palette.grey[600],
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: 10
    }
  },
  verticalAlign: {
    display: 'flex',
    verticalAlign: 'middle',
    color: theme.palette.grey[600],
    fontWeight: 500,
    lineHeight: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 10
    }
  }
}))
export default useStyles
